module.exports = __webpack_public_path__ + "static/83ea567e-6a82-47a8-9002-25f15853a222-43564d0c766d48a4f87b11aae8661612.webp";